import { DeferredRender } from "@/components/DeferedRender/DeferedRender";
import { LayoutWorkstationSidebar } from "@/components/_layouts/LayoutWorkstationSidebar/LayoutWorkstationSidebar";
import { ZIndexOrder } from "@/theme";
import { Group, ScrollArea, Stack } from "@mantine/core";
import { useDocumentTitle } from "@mantine/hooks";
import { ReactNode, memo } from "react";
import { Accordion, SidebarAccordionModule } from "./Sidebar/Accordian";
import { CollapseAllButton } from "./Sidebar/CollapseAllButton";
import { DownloadUploadButtons } from "./Sidebar/DownloadUploadButtons";
import { LoanTypeIndicator } from "./Sidebar/LoanTypeIndicator";
import {
  ShowHideButton,
  useSidebarCollapseState,
} from "./Sidebar/ShowHideButton";

export const Page = ({
  sidebarTop,
  sidebarModules,
  children,
  sidebarExtras,
  accordionId,
}: {
  sidebarTop?: ReactNode;
  sidebarModules: SidebarAccordionModule[];
  children: ReactNode;
  sidebarExtras?: ReactNode;
  accordionId: string;
}) => {
  useDocumentTitle(`ETA IQ - Model`);
  const [isCollapsed] = useSidebarCollapseState(accordionId);

  return (
    <LayoutWorkstationSidebar
      p={"xs"}
      pr={0}
      pb={0}
      hideSidebar={isCollapsed}
      sidebar={
        <Sidebar
          sidebarTop={sidebarTop}
          sidebarModules={sidebarModules}
          sidebarExtras={sidebarExtras}
          accordionId={accordionId}
        />
      }
    >
      <ShowHideButton accordionId={accordionId} />
      <DeferredRender>{children}</DeferredRender>
    </LayoutWorkstationSidebar>
  );
};

export const Sidebar = memo(
  ({
    sidebarTop,
    sidebarModules,
    sidebarExtras,
    accordionId,
  }: {
    sidebarTop?: ReactNode;
    sidebarModules: SidebarAccordionModule[];
    sidebarExtras?: ReactNode;
    accordionId: string;
  }) => {
    return (
      <Stack w={"100%"} h={"100%"} gap={0} pos={"relative"}>
        <Stack
          h={"100%"}
          justify="space-between"
          gap={0}
          pos={"relative"}
          flex={1}
          style={{
            overflow: "hidden",
          }}
        >
          <ScrollArea scrollbarSize={8}>
            <Stack
              flex={1}
              gap={"xs"}
              style={{ overflow: "hidden" }}
              pt={"xs"}
              pb={100}
              pl={"xs"}
              pr={"sm"}
            >
              <DownloadUploadButtons />
              {sidebarTop}
              <Accordion modules={sidebarModules} accordionId={accordionId} />
            </Stack>
          </ScrollArea>
        </Stack>
        <CollapseAllButton accordionId={accordionId} />
        <Group
          gap={6}
          style={{
            position: "absolute",
            bottom: 6,
            left: 6,
            zIndex: ZIndexOrder.SidebarBottomButtons,
          }}
        >
          <LoanTypeIndicator />
        </Group>

        {sidebarExtras}
      </Stack>
    );
  },
);
